import React, { useEffect } from "react";
import { search as searchIcon } from "../../assets/images/icons";
import {
  ingestData,
  isMobile,
} from "../../bridges/BridgeServices";
import useSearch from "../../hooks/useSearch";

import "./searchResults.scss";

import EmptyStateComponent from "../EmptyStateComponent/emptyStateComponent";
import Skeleton from "../Skeleton/skeleton";
import SearchedItem from "./searchedItem";
import { EVENTS } from "../../utils/constants";

const SearchResults = ({
  data = {},
  input = "",
  isSearchPage = false,
}) => {
  const { searchResult, isLoading } = useSearch(
    data,
    input
  );

  useEffect(() => {
    if (isSearchPage) {
      ingestData({
        name: EVENTS.FAQ_SEARCH_RESULT_LOADED,
        data: {
          search: input,
        },
      });
    }
  }, [input]);

  //Returns a list of react components of search results which were the result of the search

  if (input?.length < 3) {
    return null;
  }

  if (isLoading) {
    return (
      <>
        {!isMobile() && isSearchPage ? (
          <p className="search-heading">
            <Skeleton
              variant="text"
              height="40px"
              width="780px"
            />
          </p>
        ) : null}
        <div
          className={`${
            isMobile()
              ? "mobile-search-results-container"
              : isSearchPage
              ? "search-results-page-container"
              : "search-results-container"
          } search-wrapper`}
        >
          <SearchResultSkeleton />
          <SearchResultSkeleton />
          <SearchResultSkeleton />
        </div>
      </>
    );
  }

  if (!searchResult?.length && isSearchPage) {
    return (
      <EmptyStateComponent
        title={"No results Found"}
        subTitle={
          "We couldn't find what you're looking for"
        }
        icon={searchIcon}
      />
    );
  }

  return (
    <>
      {searchResult?.length &&
      !isMobile() &&
      isSearchPage ? (
        <p className="search-heading">
          Search results for "{input}"
        </p>
      ) : null}
      {searchResult?.length ? (
        <div
          className={`${
            isMobile()
              ? "mobile-search-results-container"
              : isSearchPage
              ? "search-results-page-container"
              : "search-results-container"
          } search-wrapper`}
        >
          {searchResult.map(node => (
            <SearchedItem node={node} />
          ))}
        </div>
      ) : null}
    </>
  );
};

export const SearchResultSkeleton = () => {
  return (
    <div className="search-results">
      <div className="search-results-heading-wrapper">
        <div className="search-results-heading">
          <Skeleton
            height="20px"
            className={"search-results-skeleton-heading"}
          />
        </div>
        <Skeleton
          height="24px"
          width="24px"
          variant="circular"
        />
      </div>

      <div className="search-results-subtitle">
        <Skeleton
          width="800px"
          height="10px"
          style={{ marginTop: "8px" }}
        />
        <Skeleton
          width="800px"
          height="10px"
          style={{ marginTop: "8px" }}
        />
        {!isMobile() && (
          <Skeleton
            width="800px"
            height="10px"
            style={{ marginTop: "8px" }}
          />
        )}
      </div>
    </div>
  );
};

export default SearchResults;
